import React, { Component } from "react";
import '../InitialForm/InitialFormStyleSheet.css';
import { InputGroup } from 'react-bootstrap';
import { s360ConfigService } from "../Services/S360Config";

class RadioButton extends Component {

    constructor(props) {
        super(props);
        this.messageRef = React.createRef();
    }

    render() {
        return (
            <div className="s360-initial-form-radiobutton-container" style={this.formInputBoxContainerStyle()} >
                <div className="s360-initial-form-radiobutton-label">
                    {this.props.item.label}
                </div>
                <div className="s360-initial-form-radiobutton-option" style={this.formInputBoxStyle()}>
                    <InputGroup>
                        <InputGroup.Prepend>
                            {this.props && this.props.item.options && this.props.item.options.map(eachOption => {
                                return <><InputGroup.Radio name={this.props.item.label} value={eachOption} onChange={(e) => { e.target.style.backgroundColor = "red"; e.target.style.borderColor = "red";this.onOptionChange(eachOption); }}/><span style={{paddingLeft:"5px"}}> {eachOption}</span><br /></>
                            })
                            }
                        </InputGroup.Prepend>
                    </InputGroup>
                </div >
            </div>
        );
    }

    selectedOption = null;
    onOptionChange = (option) => {
        this.selectedOption = option;
    }

    formInputBoxContainerStyle = () => {
        return {
            color: s360ConfigService.config.designDetails.headerColor,
        }
    }

    formInputBoxStyle = () => {
        return {
            borderColor:     s360ConfigService.config.designDetails.headerColor,
            backgroundColor: s360ConfigService.config.designDetails.pageBackgroundColor,
            marginTop: "5px"
        }
    }

    value = () => {
        if (!this.selectedOption) { return {} ; }
        let aValue = {};
        aValue[this.props.item.label] = this.selectedOption; 
        return aValue;
    };

    validate = () => { 
        let formItemDetails = this.props.item || {};
        let isRequired = formItemDetails.required || formItemDetails.primaryField;
        return !(isRequired && !this.selectedOption);
    }

    validationErrorMessage = () => {
        return "Please select " + this.props.item.label.toLowerCase() + ".";
    }
}

export default RadioButton;